import React, { createContext, useContext, ReactNode } from 'react';
import { useNotificationService, NotificationService } from '../services/notificationService';

const NotificationContext = createContext<NotificationService | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const notificationService = useNotificationService();

  return (
    <NotificationContext.Provider value={notificationService}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = (): NotificationService => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
